import React, { useState } from "react";
import PropTypes from "prop-types";

import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MuiNativeSelect from "@mui/material/NativeSelect";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

import { useCustomStyleMap } from "../../../utils/styles";

const selectMenuItems = (selectValues, customSx) =>
  selectValues.map(item => (
    <MenuItem key={String(item)} value={item} sx={customSx?.menuItem}>
      {item}
    </MenuItem>
  ));

/** Native `<select>` only allows `<option>` children — not `<MenuItem>` (`<li>`), which breaks HTML and hydration. */
const selectNativeOptions = selectValues =>
  selectValues.map(item => (
    <option key={String(item)} value={item}>
      {item}
    </option>
  ));

const NativeSelect = ({
  customStyle = null,
  isDesktop = true,
  value,
  defaultSelect = "",
  currentSelect = null,
  selectValues,
  onChange,
  disablePortal = false,
}) => {
  const [selectedValue, setSelectedValue] = useState(defaultSelect);
  const customSx = useCustomStyleMap(customStyle);
  const resolvedValue = currentSelect ?? selectedValue ?? defaultSelect ?? "";
  const labelId = `native-select-${value.replace(/\s+/g, "-").toLowerCase()}`;
  const buildedProps = {
    value: resolvedValue,
    onChange: event => {
      onChange(event);
      setSelectedValue(event.target.value);
    },
  };
  return (
    <FormControl
      variant="outlined"
      sx={theme => ({
        margin: theme.spacing(1),
        minWidth: 120,
        ...customSx.formControl,
      })}
    >
      <InputLabel id={labelId} htmlFor={labelId}>
        {value}
      </InputLabel>
      {isDesktop ? (
        <Select {...buildedProps} id={labelId} labelId={labelId} label={value} MenuProps={{ disablePortal }}>
          {selectMenuItems(selectValues, customSx)}
        </Select>
      ) : (
        <MuiNativeSelect {...buildedProps} id={labelId} inputProps={{ id: labelId }}>
          {selectNativeOptions(selectValues)}
        </MuiNativeSelect>
      )}
    </FormControl>
  );
};

NativeSelect.propTypes = {
  value: PropTypes.string.isRequired,
  defaultSelect: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  selectValues: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  customStyle: PropTypes.func,
  isDesktop: PropTypes.bool,
  currentSelect: PropTypes.any,
  disablePortal: PropTypes.bool,
};

export default NativeSelect;
